"use client";

import React, { FormEvent, useState } from "react";
import { LABELS, PAGE_TITLE, BUTTON_LABEL } from "@/common/constants/constants";

import styles from "./ContactForm.module.scss";

const ContactForm = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    window.location.href = `mailto:${process.env.NEXT_PUBLIC_SUPPORT_EMAIL}?subject=User:${name}&body=${message}`;
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div className={styles.wrapper}>
      <h1>{PAGE_TITLE.CONTACT_US}</h1>
      <form onSubmit={handleSubmit} className={styles.formWrapper}>
        <div className={styles.formInput}>
          <label className={styles.inputLabel} htmlFor="name">
            {LABELS.NAME}
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            className={styles.inputBody}
            required
          />
        </div>
        <div className={styles.formInput}>
          <label className={styles.inputLabel} htmlFor="email">
            {LABELS.EMAIL}
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className={styles.inputBody}
            required
          />
        </div>
        <div className={styles.formInput}>
          <label className={styles.inputLabel} htmlFor="message">
            {LABELS.MESSAGE}
          </label>
          <textarea
            id="message"
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            className={styles.textareaBody}
            required
          />
        </div>
        <button type="submit" className={styles.formButton}>
          {BUTTON_LABEL.SUMBIT}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
